module.exports = __webpack_public_path__ + "static/media/Vector.f589df19.svg";